'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBtn = exports.SecondaryBtn = exports.PrimaryBtn = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n    padding: .5em 1em;\n    border: none; \n    font-size: 1em;\n    font: inherit;\n    align-items: center;\n    position: relative;\n    cursor: pointer;\n    color: ', ';\n    border-radius: ', ';\n    box-shadow: ', ';\n    transition: .3s ease-out;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    \n    &:not(.with-icon-last){\n          // margin-left: -.5em;\n          // background: pink !important;\n    }\n   \n    &.with-icon-first{\n          // margin-left: -.5em;\n          // background: pink !important;\n          padding-left: .5em;\n    }\n\n    &.with-icon-last {\n        // margin-left: auto;\n        // padding-left: 1em;\n        padding-right: .5em;\n    }\n\n    &.disabled{\n        border: ', ';\n        box-shadow: none;\n        padding-right: 1em;\n        cursor: auto;\n        pointer-events: none;\n      }\n    &.fullWidth{\n      width: 100%;\n        span{\n          margin: 0 auto;\n        }\n      }\n\nspan{\n  position: relative;\n  top: -1px;\n}\n\n  ', '\n'], ['\n    padding: .5em 1em;\n    border: none; \n    font-size: 1em;\n    font: inherit;\n    align-items: center;\n    position: relative;\n    cursor: pointer;\n    color: ', ';\n    border-radius: ', ';\n    box-shadow: ', ';\n    transition: .3s ease-out;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    \n    &:not(.with-icon-last){\n          // margin-left: -.5em;\n          // background: pink !important;\n    }\n   \n    &.with-icon-first{\n          // margin-left: -.5em;\n          // background: pink !important;\n          padding-left: .5em;\n    }\n\n    &.with-icon-last {\n        // margin-left: auto;\n        // padding-left: 1em;\n        padding-right: .5em;\n    }\n\n    &.disabled{\n        border: ', ';\n        box-shadow: none;\n        padding-right: 1em;\n        cursor: auto;\n        pointer-events: none;\n      }\n    &.fullWidth{\n      width: 100%;\n        span{\n          margin: 0 auto;\n        }\n      }\n\nspan{\n  position: relative;\n  top: -1px;\n}\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\n    background: ', ';\n\n    color: ', ';\n\n    svg path{\n        fill: ', ';\n    }\n    \n    font-weight: 500;\n    \n    ', ';\n\n    &.disabled{\n        background: lightgrey;\n        color: #777;\n    }\n    \n    .spinner .spinnerBit{\n      background: ', ';\n    }\n\n    transition: .2s ease-out;\n    &:hover{\n      box-shadow: ', ';\n    }\n  \n  '], ['\n\n    background: ', ';\n\n    color: ', ';\n\n    svg path{\n        fill: ', ';\n    }\n    \n    font-weight: 500;\n    \n    ', ';\n\n    &.disabled{\n        background: lightgrey;\n        color: #777;\n    }\n    \n    .spinner .spinnerBit{\n      background: ', ';\n    }\n\n    transition: .2s ease-out;\n    &:hover{\n      box-shadow: ', ';\n    }\n  \n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    // background: ', ';\n    background: ', ';\n    box-shadow: none;  \n    border: ', ';\n\n\n    '], ['\n    // background: ', ';\n    background: ', ';\n    box-shadow: none;  \n    border: ', ';\n\n\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\nbackground: none;\nborder: none;\n\n'], ['\nbackground: none;\nborder: none;\n\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icons = require('./icons');

var _spinners = require('./spinners');

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Btn = _styledComponents2.default.button(_templateObject, function (_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled;
  return !disabled && theme.textColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadow;
}, function (_ref4) {
  var theme = _ref4.theme;
  return '2px solid ' + theme.middleground;
}, function (_ref5) {
  var theme = _ref5.theme,
      notification = _ref5.notification;
  return notification && notification.type !== '' && '\n        &::before {\n            content: \'\';\n            position: absolute;\n            top: 4px;\n            left: 4px;\n            height: 10px;\n            width: 10px;\n            border-radius: 50%;\n            background: ' + theme.stateColors[notification.type] + ';\n        }\n        &::after {\n            content: \'' + notification.text + '\';\n            color: ' + theme.textColor + ';\n            text-align: left;\n            background: ' + theme.stateColors[notification.type] + ';\n            border-radius: ' + theme.borderRadius + ';\n            position: absolute;\n            top: 0;\n            left: 10px;\n            overflow: visible;\n            padding: .5em;\n            opacity: 0;\n            transform: translate(0, -50%);\n            transition: .2s ease-out;\n            \n        }\n        &:hover::after{\n            transform: translate(0, -110%);\n            opacity: 1;\n        }\n  ';
});

var PBtn = (0, _styledComponents2.default)(Btn)(_templateObject2, function (_ref6) {
  var theme = _ref6.theme,
      type = _ref6.type;
  return !type ? theme.brandColor : theme.stateColors[type];
}, function (_ref7) {
  var theme = _ref7.theme;
  return (0, _chromaJs2.default)(theme.brandColor).luminance() > 0.4 ? '#333' : 'whitesmoke';
}, function (_ref8) {
  var theme = _ref8.theme;
  return (0, _chromaJs2.default)(theme.brandColor).luminance() > 0.4 ? '#333' : 'whitesmoke';
}, function (_ref9) {
  var type = _ref9.type,
      theme = _ref9.theme;
  return type === 'negative' ? 'color: whitesmoke' : type === 'warning' ? 'color: #333;' : '';
}, function (_ref10) {
  var theme = _ref10.theme;
  return (0, _chromaJs2.default)(theme.brandColor).luminance() > 0.4 ? '#333' : 'whitesmoke';
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.expandedShadow;
});

var PrimaryBtn = exports.PrimaryBtn = function PrimaryBtn(props) {
  var BtnEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (BtnEl.current.firstChild && BtnEl.current.firstChild.tagName === 'svg') {
      BtnEl.current.classList.add('with-icon-first');
    }

    if (BtnEl.current.lastChild && BtnEl.current.lastChild.tagName === 'svg') {
      BtnEl.current.classList.add('with-icon-last');
    }
  }, []);
  return _react2.default.createElement(PBtn, _extends({
    ref: BtnEl,
    className: '\n    ' + (props.disabled ? 'disabled' : '') + '\n    ' + (props.fullWidth ? 'fullWidth' : '') + '\n    '
  }, props), props.waiting === true ? _react2.default.createElement(_spinners.Spinner, null) : _react2.default.createElement(_react2.default.Fragment, null, props.backward && _react2.default.createElement(_icons.LeftChevron, null), props.children, props.forward && _react2.default.createElement(_icons.RightChevron, null)));
};

var SBtn = (0, _styledComponents2.default)(Btn)(_templateObject3, function (_ref12) {
  var theme = _ref12.theme;
  return theme.middleground;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.foreground;
}, function (_ref14) {
  var theme = _ref14.theme;
  return '1px solid ' + (0, _chromaJs2.default)(theme.middleground).darken(0.5);
});

var SecondaryBtn = exports.SecondaryBtn = function SecondaryBtn(props) {
  var BtnEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (BtnEl.current.firstChild && BtnEl.current.firstChild.tagName === 'svg') {
      BtnEl.current.classList.add('with-icon-first');
    }

    if (BtnEl.current.lastChild && BtnEl.current.lastChild.tagName === 'svg') {
      BtnEl.current.classList.add('with-icon-last');
    }
  }, []);
  return _react2.default.createElement(SBtn, _extends({
    ref: BtnEl,
    className: '\n    ' + (props.disabled ? 'disabled' : '') + '\n    ' + (props.forward ? 'forward' : '') + '\n    ' + (props.backward ? 'backward' : '') + '\n    ' + (props.fullWidth ? 'fullWidth' : '') + '\n    '
  }, props), props.waiting === true ? _react2.default.createElement(_spinners.Spinner, null) : _react2.default.createElement(_react2.default.Fragment, null, props.backward && _react2.default.createElement(_icons.LeftChevron, null), props.children, props.forward && _react2.default.createElement(_icons.RightChevron, null)));
}; // export const SecondaryBtn = ({
//   children,
//   onClick,
//   disabled,
//   style,
//   forward = false,
//   backward = false,
//   warning = false,
//   fullWidth = false,
//   waiting = false,
// }, props) => {
//   return (
//     <SBtn onClick={onClick} className={`
// ${ disabled ? 'disabled' : ''}
// ${ forward ? 'forward' : ''}
// ${ backward ? 'backward' : ''}
// ${ warning ? 'warning' : ''}
// ${ fullWidth ? 'fullWidth' : ''}
// `}
//       style={style && { ...style }}>
//       {props.waiting === true ?
//         <Spinner /> :
//         <React.Fragment>
//           {props.backward &&
//             <LeftChevron />
//           }
//           {props.children}
//           {props.forward &&
//             <RightChevron />
//           }
//         </React.Fragment>
//       }
//       {/* {backward &&
//         <LeftChevron />
//       }
//       <span>
//         {children}
//       </span>
//       {forward &&
//         <RightChevron />
//       } */}
//     </SBtn>
//   )
// }
// Not finished


var IconButton = _styledComponents2.default.button(_templateObject4);

var IconBtn = exports.IconBtn = function IconBtn(_ref15, rest) {
  var children = _ref15.children,
      onClick = _ref15.onClick,
      disabled = _ref15.disabled,
      type = _ref15.type,
      style = _ref15.style;
  return _react2.default.createElement(IconButton, {
    style: style
  }, children);
}; // export default PrimaryBtn